import classNames from 'clsx';
import React from 'react';

import styles from './ButtonGroup.scss';

export interface Props extends React.PropsWithChildren {
  className?: string;
  inline?: boolean;
  leftAlign?: boolean;
}

const ButtonGroup: React.FC<Props> = ({ children, className = '', inline, leftAlign }) => (
  <div
    className={classNames(styles.group, className, {
      [styles.inline]: inline,
      [styles.leftAlign]: leftAlign
    })}
  >
    {children}
  </div>
);

export default ButtonGroup;
